import { useEffect, type ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { HelpChatPanel } from "@/components/layout/HelpChatPanel";
import { useHelp } from "@/components/layout/HelpProvider";
import { useIsMobile } from "@/hooks/useIsMobile";

export function HelpChatDock(): ReactElement | null {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { chatOpen, closeChat } = useHelp();

  useEffect(() => {
    if (!chatOpen || isMobile) return;

    function handleKeyDown(event: KeyboardEvent): void {
      if (event.key === "Escape") closeChat();
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [chatOpen, closeChat, isMobile]);

  if (isMobile || !chatOpen) return null;

  return (
    <aside
      className="m-3 flex min-h-0 w-[345px] shrink-0 flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-sm"
      aria-label={t("help.chatTitle")}
    >
      <HelpChatPanel showClose />
    </aside>
  );
}
